import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {
  fromSeoUrl,
  toSeoUrl,
  toSingular,
  toPlural,
} from 'helpers/HelperFunctions';

import styles from './ProjectsHeader.module.scss';

const ProjectsHeader = ({
  filter = null,
  paid,
  getSelectedRoleName,
  config,
  loggedIn,
}) => {
  const locationString =
    filter && filter.city
      ? ' in ' + fromSeoUrl(filter.city) + ', ' + fromSeoUrl(filter.country)
      : filter && filter.country
      ? ' in ' + fromSeoUrl(filter.country)
      : '';

  const description = `Find & apply for work on ${
    getSelectedRoleName()
      ? toSingular(getSelectedRoleName().toLowerCase())
      : 'freelance'
  } projects${
    locationString ? locationString : ''
  }. Find the best remote and freelance jobs from clients around the world on Twine.`;

  const title = paid
    ? `${
        getSelectedRoleName() ? toSingular(getSelectedRoleName()) : 'Freelance'
      } Jobs ${
        locationString ? locationString : ' With Top Global Clients'
      } | Twine`
    : `${
        getSelectedRoleName() ? toSingular(getSelectedRoleName()) : 'Project'
      } Collaborations | Twine`;

  const getCurrentLink = () => {
    let link = config.baseUrl;

    link += paid ? '/jobs' : '/collaborate';

    if (filter) {
      if (getSelectedRoleName() !== '') {
        link += `/${toSeoUrl(toPlural(getSelectedRoleName()))}`;
      }
      if (filter.country) {
        link += filter.city
          ? `/in/${toSeoUrl(filter.country)}/${toSeoUrl(filter.city)}`
          : `/in/${toSeoUrl(filter.country)}`;
      }
    }

    return link;
  };

  return (
    <div>
      <Helmet
        title={title}
        link={[
          {
            rel: 'canonical',
            href: getCurrentLink(),
          },
        ]}
        meta={[
          { name: 'description', content: description },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          {
            property: 'og:url',
            href: getCurrentLink(),
          },
          { name: 'twitter:title', content: title },
          { name: 'twitter:description', content: description },
        ]}
      />

      <h1 className={styles.title}>
        {filter ? toSingular(getSelectedRoleName()) : ''}{' '}
        {paid ? 'Freelance and Remote Jobs' : 'Collaboration Board'}
      </h1>
      {!loggedIn && (
        <>
          <h2 className={styles.subtitle}>
            {paid ? 'Find and apply for work on freelance ' : 'Find '}
            {filter && `${toSingular(getSelectedRoleName().toLowerCase())} `}
            {paid
              ? 'projects' + (locationString ? locationString : '')
              : 'project collaborations'}
          </h2>
          {paid ? (
            <h3 className={styles.description}>
              Find the best{' '}
              {filter
                ? `freelance ${toSingular(
                    getSelectedRoleName().toLowerCase()
                  )} jobs and remote 
              ${toSingular(getSelectedRoleName().toLowerCase())} jobs `
                : 'remote and freelance jobs '}
              from clients
              {locationString ? locationString : ' around the world'}. Search
              for projects matching your{' '}
              {filter && toSingular(getSelectedRoleName().toLowerCase())} skills
              at top companies. Apply today.
            </h3>
          ) : (
            <h3 className={styles.description}>
              Browse{' '}
              {filter &&
                `for ${toSingular(getSelectedRoleName().toLowerCase())}`}{' '}
              collaboration posts
            </h3>
          )}
        </>
      )}
    </div>
  );
};

ProjectsHeader.propTypes = {
  filter: PropTypes.object,
  paid: PropTypes.bool,
  getSelectedRoleName: PropTypes.func,
  config: PropTypes.object,
  loggedIn: PropTypes.bool,
};

ProjectsHeader.defaultProps = {
  filter: null,
};

export default ProjectsHeader;
